import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const getMultimediaLevels = async () => {
    const { data } = await axios.get(API_ROUTES.MULTIMEDIA_LEVELS);
    return data;
};